export default {"src":"/_next/static/media/simple-box-icon.6cb0b0a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};